import { createApiClient } from "../api/client.js";

const api = createApiClient();

/**
 * @param {{ categoryId: string, mime: string, dataBase64: string }} payload
 */
export async function extractTrainerExpenseReceiptRemote(payload) {
  return api.post("/api/trainerstunden/expenses/extract-receipt", payload, {
    auth: true,
  });
}

/**
 * @param {File|Blob} file
 * @returns {Promise<string>}
 */
export function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || "");
        const comma = result.indexOf(",");
        resolve(comma >= 0 ? result.slice(comma + 1) : result);
      };
      reader.onerror = () => reject(reader.error || new Error("read-failed"));
      reader.readAsDataURL(file);
    } catch (e) {
      reject(e);
    }
  });
}

/**
 * @param {File|Blob} file
 * @param {string} categoryId
 */
export async function extractTrainerExpenseFromFileRemote(file, categoryId) {
  const mime = String(file?.type || "").trim();
  const dataBase64 = await readFileAsBase64(file);
  return extractTrainerExpenseReceiptRemote({
    categoryId,
    mime,
    dataBase64,
    filename:
      String(file?.name || "")
        .trim()
        .slice(0, 120) || null,
  });
}
